import { useEffect, useReducer } from "react";
import filterContext from "./filterContext";
import filterReducer from "./filterReducer";
import env from "../../config/envHelper";
// import { useSelector } from "react-redux";
// import { setDraft } from "../store/reservationSlice";

export default function FilterState({ children }) {

    // If filter changes then add these changes to draft (will be empty if draft is nulled)
    // const draft = useSelector((state) => state.reservation.draft);
    
    const initialState = {
        filter: null
    };

    useEffect(() => {
        fetchFilterObject();
    }, []);

    const fetchFilterObject = () => {
        fetch(`${env.REACT_APP_BACKEND_URL}/filters`)
            .then((response) => response.json())
            .then((data) => setFilter(data))
            .catch((error) => {
                console.error("Error fetching workshops:", error);
            });
    }

    const [state, dispatch] = useReducer(filterReducer, initialState);

    // If state (filter) changes, update draft
    // useEffect(() => {
    //     updateDraftWithFilter()
    // }, [state]);

    // const updateDraftWithFilter = () => {
    //     let selectedServices = [];
    //     state.filter?.forEach(filterItem => {
    //         filterItem.services.forEach(service => {
    //             if (service.active) {
    //                 selectedServices.push(service);
    //             }
    //         });
    //     });
    //     dispatch(setDraft({ services: { ...selectedServices, ...draft.services } }));
    // };

    const setFilter = (filter) => {
        const filterGroups = Array.isArray(filter) ? filter : filter?.filters;
        dispatch({
            type: "SET_FILTER",
            payload: Array.isArray(filterGroups) ? filterGroups : [],
        });
    };

    const setSelectedService = (serviceId) => {
        const updatedFilter = state.filter?.flatMap(filterItem => filterItem.services).map(service => {
            if (serviceId === service.id) {
                return { ...service, active: true };
            }
            return { ...service, active: false };
        }) || [];

        const filter = state.filter?.map(filterItem => {
            if (filterItem.headerName === 'availableServices') {
                return { ...filterItem, services: updatedFilter };
            }
            return filterItem;
        });

        dispatch({ type: "SET_FILTER", payload: filter });
    };

    const clearFilter = () => {
        // dispatch({ type: "CLEAR_FILTER" });
        fetchFilterObject();
    };

    return (
        <filterContext.Provider value={{ state, dispatch, setFilter, clearFilter, setSelectedService }}>
            {children}
        </filterContext.Provider>
    );
};

